import {yupResolver} from "@hookform/resolvers/yup";
import {Button, FormControl, InputLabel, MenuItem, Select, Stack, TextField} from "@mui/material";
import {Controller, useForm} from "react-hook-form";
import * as yup from "yup";
import {useNavigate} from "react-router-dom";
import useApiRequest from "../../hooks/useApiRequest";
import {snackbar} from "../../utils/snackbar";

const schema = yup.object().shape({
  name: yup.string().required("El nombre es obligatorio").max(255, "Máximo 255 caracteres"),

  nif: yup.string().required("El NIF es obligatorio").max(20, "Máximo 20 caracteres"),

  status: yup.string().required("El estado es obligatorio").oneOf(["active", "deleted"], "Estado no válido")
});

const TenantForm = ({isNew, refreshData, setIsEditing, initialTenantData}) => {
  const navigate = useNavigate();
  const {update, create} = useApiRequest({baseUrl: `/tenants`, resource: "tenants"});

  const handleSave = async (data) => {
    const result = isNew ? await create(data) : await update(initialTenantData.id, data);
    if (!result.success) return;

    refreshData();
    setIsEditing(false);

    if (isNew && result.data?.id) {
      navigate("/tenant-form", {state: {id: result.data?.id}});
      snackbar.success("Tenant creado correctamente");
    } else {
      snackbar.success("Tenant actualizado correctamente");
    }
  };

  const {
    register,
    handleSubmit,
    control,
    formState: {errors}
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialTenantData || {name: "", nif: "", status: "active"}
  });

  const onSubmit = (data) => {
    handleSave(data);
  };

  return (
    <Stack direction="column" spacing={2} minWidth={"300px"}>
      <TextField
        label="Nombre"
        {...register("name")}
        slotProps={{htmlInput: {maxLength: 255}}}
        error={!!errors.name}
        helperText={errors.name?.message}
        variant="outlined"
      />
      <TextField
        label="NIF"
        {...register("nif")}
        slotProps={{htmlInput: {maxLength: 20}}}
        error={!!errors.nif}
        helperText={errors.nif?.message}
        variant="outlined"
      />
      <FormControl variant="outlined" error={!!errors.status}>
        <InputLabel>Estado</InputLabel>
        <Controller
          name="status"
          control={control}
          render={({field}) => (
            <Select {...field} label="Estado">
              <MenuItem value="active">Activo</MenuItem>
              <MenuItem value="deleted">Inactivo</MenuItem>
            </Select>
          )}
        />
      </FormControl>
      <Button variant="contained" color="primary" onClick={handleSubmit(onSubmit)}>
        {isNew ? "Crear" : "Guardar"}
      </Button>
    </Stack>
  );
};

export default TenantForm;
